'use strict';

export default class AdminController {
  /*@ngInject*/
  constructor($rootScope) {
    this.currentAdminPageTitle = 'Users';

    let self = this;
    $rootScope.$watch('currentAdminPageTitle', function(title) {
      if(title) {
        self.currentAdminPageTitle = title;
      }
    });

    //$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      //console.log(toState);
    //});
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.js